__turbopack_context__.v({
  "animateAi": "animations-module__g3WMhG__animateAi",
  "animateMargins": "animations-module__g3WMhG__animateMargins",
  "dynamicScreenWidth": "animations-module__g3WMhG__dynamicScreenWidth",
  "expand": "animations-module__g3WMhG__expand",
  "expandAnimation": "animations-module__g3WMhG__expandAnimation",
  "fadein": "animations-module__g3WMhG__fadein",
  "gradient-shift": "animations-module__g3WMhG__gradient-shift",
  "navTransition": "animations-module__g3WMhG__navTransition",
  "navTransitionDown": "animations-module__g3WMhG__navTransitionDown",
  "navTransitionUp": "animations-module__g3WMhG__navTransitionUp",
  "rightSideNavClose": "animations-module__g3WMhG__rightSideNavClose",
  "rightSideNavOpen": "animations-module__g3WMhG__rightSideNavOpen",
  "sidebarMobileClose": "animations-module__g3WMhG__sidebarMobileClose",
  "sidebarMobileOpen": "animations-module__g3WMhG__sidebarMobileOpen",
  "smallTransitionDown": "animations-module__g3WMhG__smallTransitionDown",
  "smallTransitionIn": "animations-module__g3WMhG__smallTransitionIn",
  "smallTransitionInSlow": "animations-module__g3WMhG__smallTransitionInSlow",
  "smallTransitionInXSlow": "animations-module__g3WMhG__smallTransitionInXSlow",
  "smallTransitionUp": "animations-module__g3WMhG__smallTransitionUp",
  "transitionOpacity": "animations-module__g3WMhG__transitionOpacity",
  "transitionOpacitySlow": "animations-module__g3WMhG__transitionOpacitySlow",
  "transitionOutOpacity": "animations-module__g3WMhG__transitionOutOpacity",
  "transitionOutOpacitySlow": "animations-module__g3WMhG__transitionOutOpacitySlow",
  "transitionPadding": "animations-module__g3WMhG__transitionPadding",
});
